import imageOne from '@/assets/images/cities/yorkton1.jpg'
import imageTwo from '@/assets/images/cities/yorkton2.jpg'
import imageThree from '@/assets/images/cities/yorkton3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Yorkton',
  writeup: '',
  website: 'YorktonNotaryPublic.com',
  url: 'https://www.yorktonnotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(306) 500-5160',
      hours: {
        monday: '',
        tuesday: '',
        wednesday: '',
        thursday: '9:00AM to 5:00PM',
        friday: '9:00AM to 5:00PM',
        saturday: '',
        sunday: ''
      },
      address: '259 Hamilton Road Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/saskatchewan/cities/yorkton.js